define(function (require) {
    "use strict";
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var LpaEditView = require("personalization-user-management-views/LpaEditView");
    var ProfileAssignedToLPAModel = require("personalization-models/ProfileAssignedToLPAModel");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var LpaEditController={};
    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

        LpaEditController = BaseFeatureController.extend({
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "LpaEditController:initialize", options);
                this.profilesCollection = options.profilesCollection;
                this.lpaEditView = new LpaEditView({
                    anchorSelector: options.featureOptions.anchorSelector,
                    profilesCollection: this.profilesCollection,
                    IsLpaAssigned: options.IsLpaAssigned
                });
                this.listenTo(this.lpaEditView, "lpa:save", this._save, this);
            },

            getEditView: function (options) {
                LEPersonalization.logger.debug("return this view", "LpaEditController:getEditView", options);
                return this.lpaEditView;
            },

            _save: function (options) {
                LEPersonalization.logger.debug("save LPA assignments", "LpaEditController:_save");
                LEPersonalization.loader.setLoader();
                options = options || [];
                //we instanciate the model with this specific id in order to perform the profiles/updateIsAssignedToLPA request using backbone save method
                var profileAssignedToLPAModel = new ProfileAssignedToLPAModel({ids: options.assignedProfiles});

                //we take the last modified field from the collection
                profileAssignedToLPAModel.setLastModified(this.profilesCollection.getLastModified());
                profileAssignedToLPAModel.save(null, {
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });

            },
            _showNotifierError: function(response) {
                var errMsg = LE.translator.translate("LEFramework.errors.serverError.1100");

                if (response && response.responseError) {
                    if (!_.isEmpty(response.responseError.message)) {
                        errMsg = response.responseError.message;
                    }


                    if (response.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
                        errMsg = LE.translator.translate("LEPersonalization.userManagement.lpa.save.conflict");
                    }
                }

                LEPersonalization.notifier.showError(errMsg);
            },

            _onSaveSuccess: function (model, response) {
                LEPersonalization.logger.debug("When saving assignment was successful", "LpaEditController:_onSaveSuccess", response);
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToPageMenu();
            },

            _onSaveError: function (model, response) {
                LEPersonalization.logger.debug("When saving assignment has resulted with an error", "LpaEditController:_onSaveError", response);
                this._showNotifierError(response);
                LEPersonalization.loader.closeLoader();
            }
        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return LpaEditController;
});
